// TICHO: prev/next arrows on the desktop PDP main image.
// Navigates through the *visible* thumbnails (ticho-variant-gallery hides
// other variants' photos) by clicking them, so media-gallery.js keeps
// owning the active state, thumbnails, day/evening and lightbox.
(function () {
  function init(root) {
    if (root.dataset.tichoArrowsReady) return;
    root.dataset.tichoArrowsReady = '1';

    var gallery = root.closest('media-gallery');
    var thumbs = gallery && gallery.querySelector('[id^="GalleryThumbnails"]');
    var viewer = gallery && gallery.querySelector('[id^="GalleryViewer"]');
    if (!thumbs || !viewer) return;

    var prev = root.querySelector('[data-ticho-arrow="prev"]');
    var next = root.querySelector('[data-ticho-arrow="next"]');

    function visibleItems() {
      return Array.prototype.filter.call(thumbs.querySelectorAll('[data-target]'), function (li) {
        return li.offsetParent !== null && getComputedStyle(li).display !== 'none';
      });
    }

    function currentIndex(items) {
      for (var i = 0; i < items.length; i++) {
        var btn = items[i].querySelector('button');
        if (btn && btn.getAttribute('aria-current') === 'true') return i;
      }
      var active = viewer.querySelector('.product__media-item.is-active');
      if (active) {
        for (var j = 0; j < items.length; j++) {
          if (items[j].dataset.target === active.dataset.mediaId) return j;
        }
      }
      return 0;
    }

    function update() {
      var items = visibleItems();
      if (items.length < 2) {
        root.hidden = true;
        return;
      }
      root.hidden = false;
      var i = currentIndex(items);
      prev.disabled = i <= 0;
      next.disabled = i >= items.length - 1;
    }

    function go(step) {
      var items = visibleItems();
      var target = items[currentIndex(items) + step];
      var btn = target && target.querySelector('button');
      if (btn) btn.click();
      window.setTimeout(update, 50);
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    new MutationObserver(update).observe(thumbs, {
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-current', 'class', 'style', 'hidden'],
    });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-ticho-gallery-arrows]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
